import React from "react";
import Chart from "react-apexcharts";

const PackagesSubscriptionCountView = () => {
  const chartOptions = {
    chart: {
      id: "pie",
      toolbar: {
        show: true,
      },
    },
    labels: ["Gold", "Silver", "Platinum"],
    colors: ["#FFD700", "#C0C0C0", "#E5E4E2"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "right" as const,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val: number) => `${val} subscriptions`,
      },
    },
  };

  const chartSeries = [45, 30, 25];

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="pie"
        height={350}
      />
    </div>
  );
};

export default PackagesSubscriptionCountView;
